// Holding the activity categories shut until the visitor asks for one.
//
// A centre can list a hundred sessions under Swimming alone, so the page opens
// with every category closed and the visitor opens the one they came for.
// Opening and closing is the browser's own <details> behaviour; all this does
// is decide when a category may not be closed.
//
// Two things take that choice away, because closing would leave nothing to
// look at: a filter has already narrowed the page down, or there is only one
// category with any results.

const LOCKED_CLASS = 'weekly-timetable__category-header--locked';

// Belt and braces: the styling stops a real click landing, but a click sent
// any other way must not close a category that has to stay open.
function preventToggle(event) {
  event.preventDefault();
}

function summaryOf(category) {
  return category.querySelector('.weekly-timetable__category-header');
}

function lock(category) {
  const summary = summaryOf(category);
  category.open = true;
  if (!summary) return;
  summary.classList.add(LOCKED_CLASS);
  summary.setAttribute('tabindex', '-1');
  summary.addEventListener('click', preventToggle);
}

function unlock(category) {
  const summary = summaryOf(category);
  category.open = false;
  if (!summary) return;
  summary.classList.remove(LOCKED_CLASS);
  summary.removeAttribute('tabindex');
  summary.removeEventListener('click', preventToggle);
}

function visibleCategories(el) {
  return [...el.querySelectorAll('details.weekly-timetable__category')]
    .filter(category => category.style.display !== 'none');
}

export default function syncCategoryDisclosures(el, filtered) {
  const categories = visibleCategories(el);
  const locked = filtered || categories.length <= 1;

  categories.forEach(category => (locked ? lock(category) : unlock(category)));
}
